import { render } from "./DropboxDashboard.vue?vue&type=template&id=349b3466&scoped=true"
import script from "./DropboxDashboard.vue?vue&type=script&lang=js"
export * from "./DropboxDashboard.vue?vue&type=script&lang=js"

import "./DropboxDashboard.vue?vue&type=style&index=0&id=349b3466&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349b3466"]])

export default __exports__